import { render, staticRenderFns } from "./RedoIcon.vue?vue&type=template&id=1aec74af"
import script from "./RedoIcon.vue?vue&type=script&lang=js"
export * from "./RedoIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports